



















export default {
	name: 'PrimaryButton',

	props: {
		text: {
			required: true,
			type: String,
		},
		icon: {
			required: false,
			type: String,
		},
		disabled: {
			required: false,
			type: Boolean,
		},
		type: {
			default: 'button',
			required: false,
			type: String,
		},
		loading: {
			required: false,
			type: Boolean,
		},
		collapsed: {
			default: false,
			required: false,
			type: Boolean,
		},
	},
};
